import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import LockOpenIcon from "@material-ui/icons/LockOpen";

function LoginForm({ formik, isLoading, onForgotPassword }) {
	const [showPassword, setShowPassword] = useState(false);
	const emailInputRef = useRef(null);

	useEffect(() => {
		if (emailInputRef.current) {
			emailInputRef.current.focus();
		}
	}, []);

	return (
		<>
			<SubText>Entre com suas credenciais para acessar o portal</SubText>
			<form>
				<FieldContainer>
					<TextField
						fullWidth
						InputLabelProps={{ shrink: true }}
						id="email"
						name="email"
						label="E-mail"
						value={formik.values.email}
						onChange={formik.handleChange}
						error={formik.touched.email && Boolean(formik.errors.email)}
						helperText={formik.touched.email && formik.errors.email}
						autoComplete="off"
						variant="outlined"
						inputRef={emailInputRef}
					/>
				</FieldContainer>
				<FieldContainer>
					<TextField
						InputLabelProps={{ shrink: true }}
						fullWidth
						id="password"
						name="password"
						label="Senha"
						type={showPassword ? "text" : "password"}
						value={formik.values.password}
						onChange={formik.handleChange}
						error={
							formik.touched.password && Boolean(formik.errors.password)
						}
						helperText={formik.touched.password && formik.errors.password}
						autoComplete="off"
						variant="outlined"
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										onClick={() => setShowPassword(!showPassword)}
										edge="end"
									>
										{showPassword ? <Visibility /> : <VisibilityOff />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
				</FieldContainer>
				<ForgotPasswordLink onClick={onForgotPassword}>
					Esqueceu a senha?
				</ForgotPasswordLink>
				<ContainerButtons>
					<ButtonOptions>
						<CustomButton
							onClick={formik.handleSubmit}
							disable={isLoading}
						>
							<ContainerButtonsIcon>
								<LockOpenIcon />
							</ContainerButtonsIcon>
							<CustomButtonLabel>
								{isLoading ? <CircularProgress size={20} /> : "Entrar"}
							</CustomButtonLabel>
						</CustomButton>
					</ButtonOptions>
				</ContainerButtons>
				<input
					className="x-display"
					type="submit"
					onClick={formik.handleSubmit}
				/>
			</form>
		</>
	);
}

export default LoginForm;

const SubText = styled.p`
	font-size: 14px;
	color: #7f8c8d;
	margin: 0 auto 24px;
	text-align: center;
	font-family: 'Mulish', sans-serif;
`;

const FieldContainer = styled.div`
	display: flex;
	margin-bottom: 18px;
	justify-content: center;
	width: 100%;

	.MuiFormControl-root {
		width: 100%;
		max-width: 100%;
	}

	.MuiOutlinedInput-root {
		border-radius: 8px;
		background-color: #fff;
	}

	.MuiInputLabel-outlined {
		color: #64748b;
		font-size: 14px;
	}

	.MuiOutlinedInput-notchedOutline {
		border-color: #e2e8f0;
	}

	.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
		border-color: #cbd5e1;
	}

	.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
		border-color: #2c3e50;
		border-width: 2px;
	}
`;

const ForgotPasswordLink = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%;
	margin: -6px 0 20px;
	font-size: 13px;
	color: #667eea;
	cursor: pointer;
	font-family: 'Mulish', sans-serif;
	transition: color 0.2s ease;

	&:hover {
		color: #764ba2;
		text-decoration: underline;
	}
`;

const ContainerButtons = styled.div`
	display: flex;
	margin-top: 28px;
	margin-bottom: 24px;
	justify-content: center;
	width: 100%;
`;

const ButtonOptions = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
`;

const CustomButton = styled.div`
	align-items: center;
	justify-content: center;
	margin: 0;
	padding: 14px 24px;
	background-color: ${(props) => (props.disable ? "#94a3b8" : "#2c3e50")};
	border-radius: 8px;
	display: flex;
	color: white;
	height: 48px;
	width: 100%;
	font-weight: 600;
	transition: all 0.2s ease;
	${({ disable }) =>
		!disable &&
		`
     cursor: pointer;
     &:hover {
       background-color: #1a252f;
       transform: translateY(-1px);
       box-shadow: 0 4px 12px rgba(44, 62, 80, 0.2);
     }
     &:active {
       transform: translateY(0);
     }
  `}
`;

const CustomButtonLabel = styled.span`
	font-size: 14px;
	font-weight: 600;
	letter-spacing: 0.3px;
`;

const ContainerButtonsIcon = styled.div`
	margin-right: 10px;
	display: flex;
	align-items: center;
`;
